import styled from 'styled-components'

import { getColor, getFontFamily } from 'utils/rebrandingUtils'

export const DefaultErrorContainer = styled.div`
  height: calc(100vh - 8rem);
  margin: 6rem 12rem 2rem 12rem;
  position: relative;
`

export const Title = styled.div`
  color: ${({ theme }) => getColor(theme, 'NEUTRAL_500')};
  font-family: ${({ theme }) => getFontFamily(theme, 'headline')};
  font-size: 6rem;
  font-weight: 500;
  line-height: 100%;
  margin-bottom: 4rem;
`

export const Body = styled.p`
  color: ${({ theme }) => getColor(theme, 'NEUTRAL_800')};
  font-family: ${({ theme }) => getFontFamily(theme, 'body')};
  font-size: 1rem;
  font-weight: 400;
  line-height: 162.5%;
`

export const ImageContainer = styled.div`
  bottom: 0;
  position: absolute;
  right: 0;
`
